import { FC } from "react";
import s from "./style.module.css";

export const Title: FC<{ label: string }> = ({ label }) => {
  return <h1 className={s.title}>{label}</h1>;
};
